import { render, staticRenderFns } from "./QuestionCommentHolder.vue?vue&type=template&id=c12ba320&"
import script from "./QuestionCommentHolder.vue?vue&type=script&lang=js&"
export * from "./QuestionCommentHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports